import React from 'react';
import { Wallet, Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';
import { useHapticFeedback } from '../../hooks/useHapticFeedback';
import { GRADIENT_CLASS } from '../../lib/gradients';

type PaymentMethod = 'stars' | 'crypto';

interface PaymentMethodSelectorProps {
  paymentMethod: PaymentMethod;
  onPaymentMethodChange: (method: PaymentMethod) => void;
}

export const PaymentMethodSelector: React.FC<PaymentMethodSelectorProps> = ({
  paymentMethod,
  onPaymentMethodChange
}) => {
  const { t } = useTranslation();
  const { impactOccurred } = useHapticFeedback();

  const handlePaymentMethodToggle = (method: PaymentMethod) => {
    impactOccurred('medium');
    onPaymentMethodChange(method);
  };

  return (
    <div className="flex gap-2">
      <button
        className={cn(
          'flex-1 flex items-center justify-center gap-1.5 py-2.5 bg-tg-secondary-bg border border-pink-500/10 rounded-xl text-tg-hint text-sm cursor-pointer transition-all duration-200 font-medium',
          paymentMethod === 'stars' && `${GRADIENT_CLASS} text-white border-transparent`
        )}
        onClick={() => handlePaymentMethodToggle('stars')}
      >
        <Star size={16} />
        {t('PROFILE_SCREEN.PREMIUM.TELEGRAM_STARS')}
      </button>
      <button
        className={cn(
          'flex-1 flex items-center justify-center gap-1.5 py-2.5 bg-tg-secondary-bg border border-pink-500/10 rounded-xl text-tg-hint text-sm cursor-pointer transition-all duration-200 font-medium',
          paymentMethod === 'crypto' && `${GRADIENT_CLASS} text-white border-transparent`
        )}
        onClick={() => handlePaymentMethodToggle('crypto')}
      >
        <Wallet size={16} />
        {t('PROFILE_SCREEN.PREMIUM.CRYPTO')}
      </button>
    </div>
  );
};

